import { FEATURE_TOGGLE } from './types';
import Cookies from 'js-cookie';

const FEATURE_TOGGLES_KEY = 'featureToggles';

export const setFeatureToggles = (togglesConfig: Map<string, boolean>): void => {
  Cookies.set(FEATURE_TOGGLES_KEY, JSON.stringify(togglesConfig));
};

export const getFeatureToggles = (): Map<string, boolean> => {
  const toggles = Cookies.getJSON(FEATURE_TOGGLES_KEY);
  return new Map(Object.entries(toggles || {}));
};

export const removeFeatureToggles = (): void => {
  Cookies.remove(FEATURE_TOGGLES_KEY);
};

export const isToggleOn = (toggleName: FEATURE_TOGGLE): boolean => {
  const toggleConfig = getFeatureToggles().get(toggleName);
  return toggleConfig !== undefined && toggleConfig;
};
